export const CHANGE_AUTHOR_INFO = "CHANGE_AUTHOR_INFO";